export default "__VITE_ASSET__6KgDYspn__"